var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelIconOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,3l-10,2v14l10,2zM14,5v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h7c0.552,0 1,-0.448 1,-1v-12c0,-0.552 -0.448,-1 -1,-1zM18,7h2v2h-2zM4.17578,8.29688h1.77734l0.92383,2.21484c0.075,0.181 0.13145,0.39091 0.18945,0.62891h0.02539c0.033,-0.143 0.10017,-0.36148 0.20117,-0.64648l1.0293,-2.19727h1.62109l-1.93555,3.66992l1.99219,3.73633h-1.72852l-1.11328,-2.41406c-0.042,-0.085 -0.09181,-0.25614 -0.13281,-0.49414h-0.01562c-0.025,0.114 -0.07539,0.28467 -0.15039,0.51367l-1.12305,2.39453h-1.73633l2.06055,-3.70703zM18,11h2v2h-2zM18,15h2v2h-2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIconOutlined);
export default __webpack_public_path__ + "static/media/excelIconOutlined.6de3ee68da2ee3fcabd5bbf3fa7094bd.svg";
export { ForwardRef as ReactComponent };